// import User from "~/models/user";
import Selected from "../store/modules/selected";
import Organization from "~/models/organization";
import Dashboard from "~/models/dashboards/dashboard";
import DashboardElement from "~/models/dashboards/dashboardElement";
import {RouteHelper} from "~/helpers/routeHelper";
import routerMixin from "~/mixins/routerMixin";
import {Route} from "~/enums/route";
import * as dataTableUtils from "~/models/visualizations/dataTableUtils";
import {BarLayoutOptions} from "~/enums/visualizationType";


interface DashboardFilters {
  filters_display: string,
  searchkick_query: object
}
export default {
  methods: {
    addFilterToFilterObject(filterObject, dataPoint, value){
      filterObject[`dashboard_drilldown_filter_${dataPoint.client_id}`] = value
    },
    addConditionalRuleFilterToFilterObject(filterObject, dataPoint){
      filterObject[`dashboard_drilldown_conditional_filter_${dataPoint.client_id}`] = "true"
    },
    buildDrilldownLink(dashboardElement, filters){
      // this is not great
      const from = (window.location.href.match(/preview/)) ? 'DashboardPreview' : 'Dashboard'
      const query = Object.assign({from, from_dashboard_id: dashboardElement.rootModel.id, visualization_id: dashboardElement.visualization_id, drill_down: true}, filters)
      if (!!dashboardElement.list_view_id ){
        if(from === 'DashboardPreview'){
          return RouteHelper.path({route: Route.previewListView, modelOrId: dashboardElement.list_view_id, query: query });
        }else if (from === 'Dashboard'){
          return RouteHelper.path({route: Route.listView, modelOrId: dashboardElement.list_view_id, query: query });
        }
      }
      else if(!!dashboardElement.form_id){
        return RouteHelper.path({route: Route.formAnalystDashboardListView, modelOrId: dashboardElement.form_id, query: query});
      }
    },
    buildSummaryCardFilters(){
      const filters_obj = {}
      let data_point = this.visualization.valueDataPointsArray[0]
      if (data_point.is_filtered){
        this.addConditionalRuleFilterToFilterObject(filters_obj, data_point)
      }
      return filters_obj

    },
    buildBarGraphFilters(visualization, barData){
      const filters_obj = {}
      const data_point = this.visualization.bar_layout === BarLayoutOptions.Vertical  ? this.visualization?.rowDataPointsArray[0] : this.visualization?.columnDataPointsArray[0];
      const value = data_point.isAccountRelationship ? `${data_point.referenceNameOrDefault} - ${barData.x}` : barData.x
      this.addFilterToFilterObject(filters_obj, data_point, value)

      const rowDataPont = this.visualization?.rowDataPointsArray[0]
      const colDataPoint = this.visualization?.columnDataPointsArray[0]
      if (rowDataPont.is_filtered){
        this.addConditionalRuleFilterToFilterObject(filters_obj, rowDataPont)
      }
      if (colDataPoint.is_filtered){
        this.addConditionalRuleFilterToFilterObject(filters_obj, colDataPoint)
      }
      return filters_obj
    },
    //Data tables apply at most 2 filters finding filter applied at intersection row_header[rowIndex] and col_header[cellIndex]
    buildDataTableFilters(visualization, rowIndex, colIndex) {
      const columnHeader = this.getColumnHeaders[colIndex]
      const colDataPoint = this.visualization.column_data_points[columnHeader.client_id]
      const colFilterValue = !!colDataPoint && colDataPoint.isAccountRelationship ? `${colDataPoint.referenceNameOrDefault} - ${columnHeader.title}` : columnHeader.title
      let rowDataPoint
      let valueDataPoint
      const filters_obj = {}
      if(rowIndex !== null) {
        const rowHeader = this.getRowHeaders[rowIndex]
        rowDataPoint = this.visualization.row_data_points[rowHeader.client_id]
        const rowFilterValue = !!rowDataPoint && rowDataPoint.isAccountRelationship ? `${rowDataPoint.referenceNameOrDefault} - ${rowHeader.title}` : rowHeader.title

        if (rowFilterValue !== "Total" && !!rowDataPoint) {
          this.addFilterToFilterObject(filters_obj, rowHeader, rowFilterValue)
          if (rowDataPoint.is_filtered) {
            this.addConditionalRuleFilterToFilterObject(filters_obj, rowDataPoint)
          }

        }
      }

      if (!!rowDataPoint){
        valueDataPoint = this.visualization.valueDataPointsArray.find( x=> x.referenced_row_client_id === rowDataPoint?.client_id  )

      } else if (!!colDataPoint){
        valueDataPoint = this.visualization.valueDataPointsArray.find( x=> x.referenced_col_client_id === colDataPoint?.client_id )
      }

      if (valueDataPoint.is_filtered){
        this.addConditionalRuleFilterToFilterObject(filters_obj, valueDataPoint)
      }

      if (colFilterValue !== "Total" && !!colDataPoint){
        this.addFilterToFilterObject(filters_obj, colDataPoint, colFilterValue)
        if (colDataPoint.is_filtered){
          this.addConditionalRuleFilterToFilterObject(filters_obj, colDataPoint)
        }
      }
      return filters_obj
    },
  }
}